import {GridColumnGroupingModel} from '@mui/x-data-grid-pro'

/**
 * 검수 조회 그리드 헤더.
 * 한 셀에 값이 두 줄로 들어가는 컬럼은 그룹 헤더를 윗줄로 세워
 * 헤더도 셀과 같은 순서로 읽히게 한다.
 */
export const deviceCheckGroup: GridColumnGroupingModel = [
  {
    groupId: '단말기 S/N',
    headerAlign: 'center',
    description: '단말기에 관한 정보입니다.',
    children: [{field: 'serialNumber'}],
  },
  {
    groupId: 'IMEI',
    headerAlign: 'center',
    description: '단말기에 관한 정보입니다.',
    children: [{field: 'imei'}],
  },
  {
    groupId: '단말정보 전송 일시',
    headerAlign: 'center',
    description: '윗줄은 단말정보가 마지막으로 전송된 시각, 아랫줄은 이미지가 마지막으로 전송된 시각입니다.',
    children: [{field: 'serverConnectAt'}],
  },
]

/**
 * 할당 조회 그리드 헤더. 검수 조회와 같은 규칙으로 맞춘다.
 */
export const deviceAssignGroup: GridColumnGroupingModel = [
  {
    groupId: '단말기 S/N',
    headerAlign: 'center',
    description: '단말기에 관한 정보입니다.',
    children: [{field: 'serialNumber'}],
  },
  {
    groupId: 'IMEI',
    headerAlign: 'center',
    description: '단말기에 관한 정보입니다.',
    children: [{field: 'imei'}],
  },
  {
    groupId: '단말정보 전송 일시',
    headerAlign: 'center',
    description: '윗줄은 단말정보가 마지막으로 전송된 시각, 아랫줄은 이미지가 마지막으로 전송된 시각입니다.',
    children: [{field: 'serverConnectAt'}],
  },
]
